<template>
  <div>
    <div
      class="card stage-registration-card"
      v-bind:class="remainingCapacity > 0 ? 'is-capacity-left' : ''"
    >
      <header class="card-header">
        <p class="card-header-title">
          {{ timeTitle }}<br>
          <small class="has-text-weight-normal has-text-grey">Première séance le {{ stage.start_date | dateFormat }}</small>
        </p>
      </header>
      <div class="card-content pb-3 pt-3">
        <p class="text-center has-text-weight-bold mb-2">
          {{ stage.small_name }}
        </p>
        <p class="text-center has-text-weight-bold">
          {{ age }} -
          <span>
            <b-icon size="is-small" icon="circle" :style="`font-size: 0.8em; color: ${stage.level.color_code}`" />
            {{ stage.level.name }}
          </span>
        </p>
        <p class="text-center mt-2 mb-2">
          <span
            v-if="remainingCapacity > 0"
            class="tag is-medium is-rounded"
          >
            {{ remainingCapacity }} places restantes
          </span>
          <span
            v-else
            class="tag is-medium is-rounded has-text-danger"
          >
            Complet
          </span>
        </p>
        <p class="text-center">
          {{ stage.number_of_lesson }} séances
        </p>

        <div
          v-if="!addedToCard"
          class="text-center mt-2 mb-2"
        >
          <b-button
            v-if="remainingCapacity > 0"
            :loading="loadingAddToCard"
            rounded
            icon-left="cart"
            type="is-primary"
            @click="addToCard"
          >
            Inscrire {{ customer.firstname }}
          </b-button>

          <osv-app-alert
            :scrolling="false"
            osv-alert-position="osv-alert-relative"
            :direct-error="addToBasketErrors"
          />
        </div>
        <div v-else>
          <div class="message is-success mt-2 mb-2">
            <div class="message-body">
              <b-icon icon="cart-plus" class="has-text-success mr-1" />
              cours ajouté au
              <a :href="osvConfig.paths.cartProduct">
                {{ $t("cart") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateHelpers } from "@/mixins/DateHelpers";
import moment from "moment";
import VueI18n from "vue-i18n";
import store from "@/store";
import {ConfigMixin} from "@/mixins/ConfigMixin";
import {LocaleMixin} from "@/mixins/LocaleMixin";
import OsvAppAlert from "@/components/shared/OsvAppAlert.vue";

export default {
  components: { OsvAppAlert },
  store,
  name: 'StageRegistrationCard',
  mixins: [DateHelpers, ConfigMixin, LocaleMixin],

  props: {
    stage: {
      type: Object,
      required: true
    },
    customer: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loadingAddToCard: false,
      addedToCard: false,
      addToBasketErrors: null
    }
  },

  computed: {
    timeTitle () {
      return `Le ${this.days} de ${moment(this.stage.start_time).format('HH:mm')} à ${moment(this.stage.end_time).format('HH:mm')}`;
    },

    days () {
      const days = [];
      for (const day of this.stage.repetition_days) {
        days.push(this.$t(`days.day${day}`))
      }
      return days.join(', ');
    },

    age () {
      if (this.stage.min_age >= 18) {
        return `Adulte`;
      } else if (this.stage.min_age !== this.stage.max_age) {
        return `${this.stage.min_age}-${this.stage.max_age} ans`;
      } else {
        return `${this.stage.min_age} ans`;
      }
    },

    remainingCapacity () {
      return this.stage.remaining_capacity - this.stage.reservations_in_baskets;
    },
  },

  methods: {
    addToCard() {
      this.loadingAddToCard = true;
      store
          .dispatch("cart/addPlannedStages",
            {
              planned_stages: [
                  {
                    customer: {
                      firstname: this.customer.firstname,
                      lastname: this.customer.lastname,
                      date_of_birth: this.customer.date_of_birth
                    },
                    planned_stage_id: this.stage.id
                  }
              ],
            }
          )
          .then(() => {
            this.addedToCard = true
          })
          .catch((err) => {
            this.addToBasketErrors = { event: 'OsvAlert_ErrorFromApi', err: err, object: 'planned_stage' };
          })
          .finally(() => {
            this.loadingAddToCard = false;
          });
    }
  },

  // Translate component
  mounted() {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {},
      fr: {
        cart: 'panier',
        days: {
          day0: "Dimanche",
          day1: "Lundi",
          day2: "Mardi",
          day3: "Mercredi",
          day4: "Jeudi",
          day5: "Vendredi",
          day6: "Samedi"
        },
      }
    }
  })
}
</script>

<style lang="scss">
.stage-registration-card {
  .stage-card-subscription {
    padding: 1em;
  }
  .card-header-title {
    line-height: 1.25em;
    display: block;
  }
  .stage-card-customers-tag {
    .is-success.is-light {
      background-color: rgb(239, 250, 245);
      color: rgb(37, 121, 83);
      border-style: solid;
      border-width: 1px;
      border-color: rgb(37, 121, 83);
    }
  }
}
</style>
